module.exports = __webpack_public_path__ + "img/camper_exteriour_3.dd0e3d0e.jpg";